import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'app-dialog-disable-automatic-bid',
  templateUrl: './dialog-disable-automatic-bid.component.html',
  styleUrls: ['./dialog-disable-automatic-bid.component.scss']
})
export class DialogDisableAutomaticBidComponent implements OnInit {

  minutes: number = 10;
  finishDate: string;
  constructor(
    private dialogRef: MatDialogRef<DialogDisableAutomaticBidComponent>,
  ) { }

  ngOnInit() {
  }

  @HostListener('window:keyup.esc')
  onNoClick(): void {
    this.dialogRef.close();
  }

  onClickConfirm(): void{
    this.dialogRef.close({disable: true});
  }

}
